<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow: auto; height: calc(100vh - 179px)">
            <es-org-tree
              @clickByOrg="queryFaultList"
              @completed="initOrgTree"
            ></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i
            >故障
          </div>
          <div class="es-op-box">
            <el-date-picker
              style="float: left; width: 280px"
              format="yyyy-MM-dd"
              v-model="dateTime"
              type="daterange"
              size="small"
              class="query"
              range-separator="至"
              start-placeholder="上报日期开始"
              end-placeholder="上报日期结束"
              clearable
              @clear="
                () => {
                  this.dateTime = [];
                }
              "
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              "
            >
            </el-date-picker>

            <el-select
              style="float: left"
              class="query"
              size="small"
              v-model="queryObj.systemId"
              placeholder="请选择系统专业"
              clearable
              filterable
              @clear="
                () => {
                  this.queryObj.pageNum = 1;
                  delete this.queryObj.systemId;
                  loadFaultList();
                }
              "
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              "
            >
              <el-option
                v-for="item in systems"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              style="float: left"
              class="query"
              size="small"
              v-model="queryObj.states"
              placeholder="请选择状态"
              clearable
              filterable
              @clear="
                () => {
                  delete this.queryObj.states;
                }
              "
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              "
            >
              <el-option
                v-for="item in statesArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-input
              placeholder="请输入故障单号"
              v-model="queryObj.keyWord"
              size="small"
              class="query"
              style="float: left"
              clearable
              @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadFaultList();
                }
              "
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <br /><br />
          <el-table
            :data="pageData.list"
            ref="faultTable"
            show-overflow-tooltip
            border
            stripe
            size="mini"
            height="calc(100vh - 250px)"
            v-loading="loading"
          >
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center"
            >
            </el-table-column>

            <el-table-column prop="code" label="故障单号"> </el-table-column>
            <el-table-column prop="systemName" label="系统专业">
            </el-table-column>
            <el-table-column prop="orgName" label="所属组织"> </el-table-column>
            <el-table-column prop="equiName" label="设备名称">
            </el-table-column>
            <el-table-column prop="occuTime" label="上报时间" width="150px">
            </el-table-column>
            <el-table-column prop="duration" label="规定时长">
              <template slot-scope="scope">
                <span style="color: orange">{{ scope.row.duration }}小时</span>
              </template>
            </el-table-column>
            <el-table-column prop="planSolveTime" label="规定完成时间" width="150px">
              <template slot-scope="scope">
                <span style="color: orange">{{ scope.row.planSolveTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="appeName"
              :show-overflow-tooltip="true"
              label="故障现象"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.appeId == 999999
                    ? scope.row.des == null
                      ? ""
                      : scope.row.des
                    : scope.row.appeName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="state"
              label="状态"
              width="165"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag size="mini" :type="stateFormat(scope.row, 1)">{{
                  scope.row.statename
                }}</el-tag>
                <el-tag
                  size="mini"
                  type="danger"
                  style="margin-left: 4px"
                  v-if="
                    scope.row.process != null &&
                    scope.row.process.startsWith('挂起')
                  "
                  >挂起</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" width="50" align="center">
              <template slot-scope="scope">
                <el-link
                  :underline="false"
                  title="详情"
                  @click="view(scope.row)"
                  type="success"
                  ><i class="el-icon-font el-icon-view"></i
                ></el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination
              :data="pageData"
              @change="
                (cpage) => {
                  this.queryObj.pageNum = cpage;
                  this.loadFaultList();
                }
              "
            >
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!--查看详情-->
    <el-dialog
      :visible.sync="viewVisible"
      width="1200px"
      style="padding-top: 0px"
    >
      <span slot="title">
        <i class="el-icon-font el-icon-view el-icon--left"></i>故障详情
      </span>
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="上报信息" name="first">
          <el-tabs type="card">
            <el-tab-pane label="基本信息">
              <div v-loading="viewLoading">
                <el-descriptions
                  :column="3"
                  style="cursor: pointer; margin-bottom: 12px"
                  size="mini"
                  border
                >
                  <el-descriptions-item
                    label="故障单号"
                    :labelStyle='labelStyle'
                    v-if="faultInfo.code != '' && faultInfo.code != null"
                    >{{ faultInfo.code }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="所属组织"
                    :labelStyle='labelStyle'
                    v-if="faultInfo.orgName != '' && faultInfo.orgName != null"
                    >{{ faultInfo.orgName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="所属区域"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.areaName != '' && faultInfo.areaName != null
                    "
                    >{{ faultInfo.areaName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="所属系统"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.systemName != '' && faultInfo.systemName != null
                    "
                    >{{ faultInfo.systemName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="设备类型"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.equiTypeName != '' &&
                      faultInfo.equiTypeName != null
                    "
                    >{{ faultInfo.equiTypeName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="设备型号"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.equiModelName != '' &&
                      faultInfo.equiModelName != null
                    "
                    >{{ faultInfo.equiModelName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="设备名称"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.equiName != '' && faultInfo.equiName != null
                    "
                    >{{ faultInfo.equiName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="设备模块"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.equiModuleName != '' &&
                      faultInfo.equiModuleName != null
                    "
                    >{{ faultInfo.equiModuleName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="上报时间"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.occuTime != '' && faultInfo.occuTime != null
                    "
                    >{{ faultInfo.occuTime }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="上报人"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.reporteName != '' &&
                      faultInfo.reporteName != null
                    "
                    >{{ faultInfo.reporteName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="解决人"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.resolverName != '' &&
                      faultInfo.resolverName != null
                    "
                    >{{ faultInfo.resolverName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="协作人"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.companionName != '' &&
                      faultInfo.companionName != null
                    "
                    >{{ faultInfo.companionName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="规定解决时长"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.duration != '' && faultInfo.duration != null
                    "
                    >{{ faultInfo.duration }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="规定解决时间"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.planSolveTime != '' &&
                      faultInfo.planSolveTime != null
                    "
                    >{{ faultInfo.planSolveTime }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="故障等级"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.levelName != '' && faultInfo.levelName != null
                    "
                    >{{ faultInfo.levelName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="故障现象"
                    :labelStyle='labelStyle'
                    v-if="
                      faultInfo.appeName != '' && faultInfo.appeName != null
                    "
                    >{{ faultInfo.appeName }}</el-descriptions-item
                  >
                  <el-descriptions-item
                    label="故障描述"
                    :labelStyle='labelStyle'
                    v-if="faultInfo.des != '' && faultInfo.des != null"
                    >{{ faultInfo.des }}</el-descriptions-item
                  >
                  <el-descriptions-item label="当前状态" :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ stateFormat(faultInfo, 2) }}</el-tag>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item label="是否专工" :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ isProfFormat(faultInfo) }}</el-tag>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item label="是否曾经激活" :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ isActivedFormat(faultInfo) }}</el-tag>
                    </div>
                  </el-descriptions-item>
                  <el-descriptions-item label="来源" :labelStyle='labelStyle'>
                    <div style="width: 200px">
                      <el-tag>{{ sourceFormat(faultInfo) }}</el-tag>
                    </div></el-descriptions-item
                  >
                </el-descriptions>

                <es-img
                  :info="faultInfo"
                  :fileList="fileListView"
                  type="view"
                ></es-img>

                <!-- 扩展属性 -->
                <es-extend :extendData="extendData" type="view"></es-extend>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>

        <el-tab-pane label="解决信息" name="second">
          <el-tabs type="card">
            <el-tab-pane label="基本信息">
              <div v-loading="viewLoading">
              <el-descriptions
                :column="3"
                style="cursor: pointer; margin-bottom: 12px"
                size="mini"
                border
              >
                <el-descriptions-item
                  label="到场时间"
                  :labelStyle='labelStyle'
                  v-if="
                    faultInfo.arriveTime != '' && faultInfo.arriveTime != null
                  "
                  >{{ faultInfo.arriveTime }}</el-descriptions-item
                >
                <el-descriptions-item
                  label="解决时间"
                  :labelStyle='labelStyle'
                  v-if="
                    faultInfo.solveTime != '' && faultInfo.solveTime != null
                  "
                  >{{ faultInfo.solveTime }}</el-descriptions-item
                >
                <el-descriptions-item
                  label="解决人"
                  :labelStyle='labelStyle'
                  v-if="
                    faultInfo.resolverName != '' &&
                    faultInfo.resolverName != null
                  "
                  >{{ faultInfo.resolverName }}</el-descriptions-item
                >
                <el-descriptions-item
                  label="解决方法"
                  :labelStyle='labelStyle'
                  v-if="
                    faultInfo.solutionName != '' &&
                    faultInfo.solutionName != null
                  "
                  >{{ faultInfo.solutionName }}</el-descriptions-item
                >
                <el-descriptions-item
                  label="解决方法描述"
                  :labelStyle='labelStyle'
                  v-if="
                    faultInfo.solutionDes != '' && faultInfo.solutionDes != null
                  "
                  >{{ faultInfo.solutionDes }}</el-descriptions-item
                >
                <el-descriptions-item
                  label="解决措施"
                  :labelStyle='labelStyle'
                  v-if="faultInfo.measures != '' && faultInfo.measures != null"
                  >{{ faultInfo.measures }}</el-descriptions-item
                >
                <el-descriptions-item label="当前状态" :labelStyle='labelStyle'>
                  <div style="width: 200px">
                    <el-tag>{{ stateFormat(faultInfo, 2) }}</el-tag>
                  </div>
                </el-descriptions-item>
              </el-descriptions>
              <!-- 扩展属性 -->
              <es-extend :extendData="extendDataSolve" type="view"></es-extend>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>

        <el-tab-pane label="材料消耗" name="third">
          <el-table
            :data="matConsume"
            ref="matConsumeTable"
            show-overflow-tooltip
            border
            stripe
            size="mini"
            height="calc(70vh - 250px)"
            v-loading="loading"
          >
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="matTypeName" label="材料类型">
            </el-table-column>
            <el-table-column prop="matModelName" label="材料型号">
            </el-table-column>
            <el-table-column prop="unit" label="单位"> </el-table-column>
            <el-table-column prop="quantity" label="数量"> </el-table-column>
            <el-table-column prop="matNumber" label="材料序列号">
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="处理过程" name="fourth">
          <el-row :gutter="20">
            <el-col :span="6">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="16">
              <div class="block" v-loading="viewLoading">
                <el-timeline>
                  <el-timeline-item
                    v-for="(activity, index) in activities"
                    :key="index"
                    :icon="activity.icon"
                    :type="activity.type"
                    :color="activity.color"
                    :size="activity.size"
                    :timestamp="activity.timestamp"
                  >
                    {{ activity.content }}
                  </el-timeline-item>
                </el-timeline>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import esExtend from "../common/es-extend.vue";
import dateutils from "../../utils/dateutils.js";

export default {
  components: { esExtend },
  name: "faultdist",
  props: ["funcs", "paramId"],
  data() {
    return {
      //label样式
      labelStyle: { 'width': '120px' },
      orgTree: [], //所属组织
      statesArr: [
        { id: 1, name: "待分配" },
        { id: 2, name: "待解决" },
        { id: 3, name: "已解决" },
      ], //状态
      systems: [], //系统专业
      dateTime: [], //上报起止日期
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      editVisible: false,
      faultInfo: {}, //故障信息
      fauProcess: {}, //故障处理过程信息
      activeName: "first",
      extendDataReport: [], //上报信息的扩展信息
      extendDataSolve: [], //解決信息的扩展信息
      viewVisible: false,
      loading: false,
      viewLoading: false,
      repairInfo: {},
      activeRepairName: "first",
      fileRepairListView: [],
      fileRepairHandleList: [],
      url: "",
      fileList: [],
      fileListView: [],
      fileListViewHandle: [],
      activities: [], //处理过程
      matConsume: [], //材料消耗
    };
  },
  methods: {
    //页面初始化
    init() {
      this.loadSystemListAll();
      this.loadFaultList();
      //弹出详情
      if (this.paramId != null) {
        this.viewVisible = false;
        this.view({ id: this.paramId });
      }
    },

    initOrgTree(orgTree) {
      this.orgTree = orgTree;
    },

    //初始化系统下拉框
    loadSystemListAll() {
      this.$ajax
        .get("/base/system/list_all")
        .then((msg) => {
          this.systems = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    //从后台查询故障列表
    loadFaultList() {
      this.loading = true;

      this.$set(this.queryObj, "occuTimeStart", null);
      this.$set(this.queryObj, "occuTimeEnd", null);
      //上报起止日期格式化
      if (this.dateTime != null && this.dateTime.length != 0) {
        this.$set(
          this.queryObj,
          "occuTimeStart",
          dateutils.dateFormat("YYYY-mm-dd", this.dateTime[0]) + " 00:00:00"
        );
        this.$set(
          this.queryObj,
          "occuTimeEnd",
          dateutils.dateFormat("YYYY-mm-dd", this.dateTime[1]) + " 23:59:59"
        );
      }

      this.$set(this.queryObj, "orderBy", "state asc,create_time desc");
      this.$ajax
        .get("/buss/fault/list", this.queryObj)
        .then((msg) => {
          this.pageData = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },

    queryFaultList(orgIds) {
      this.queryObj.pageNum = 1;
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(",");
      }
      this.loadFaultList();
    },

    //查看故障详情
    view(row) {
      this.viewVisible = true;
      this.viewLoading = true;
      this.fileListView = [];
      this.fileListViewHandle = [];
      this.activeName = "first";
      this.$ajax
        .get("/buss/fault/load_detail", { id: row.id })
        .then((msg) => {
          //初始化图片
          if (msg.attachImgs != null && msg.attachImgs != "") {
            let temp = JSON.parse(msg.attachImgs);
            temp.forEach((e) => {
              this.fileListView.push(
                this.$api +
                  e.url +
                  "&platform=web&token=" +
                  this.$store.getUser().token
              );
            });
          }
          if (msg.handleImgs != null && msg.handleImgs != "") {
            let temp = JSON.parse(msg.handleImgs);
            temp.forEach((e) => {
              this.fileListViewHandle.push(
                this.$api +
                  e.url +
                  "&platform=web&token=" +
                  this.$store.getUser().token
              );
            });
          }

          this.faultInfo = msg;
          //加载解決扩展属性
          this.$ajax
            .get("/buss/fault/extend_data", {
              fauId: this.faultInfo.id,
              typeId: 1,
            })
            .then((msg) => {
              this.extendDataReport = msg;
            })
            .catch((err) => {
              this.$message.error(err);
            });

          //加载解決扩展属性
          this.$ajax
            .get("/buss/fault/extend_data", {
              fauId: this.faultInfo.id,
              typeId: 2,
            })
            .then((msg) => {
              this.extendDataSolve = msg;
            })
            .catch((err) => {
              this.$message.error(err);
            })
            .finally(() => {
              this.viewLoading = false;
            });
        })
        .catch((err) => {
          this.$message.error(err);
          this.viewVisible = false;
          this.viewLoading = false;
        });
    },
    isProfFormat(row) {
      if (row.isProf == 0) {
        return "否";
      } else {
        return "是";
      }
    },
    isActivedFormat(row) {
      if (row.isActived == 0) {
        return "否";
      } else {
        return "是";
      }
    },
    sourceFormat(row) {
      if (row.source == 1) {
        return "手机端";
      } else {
        return "WEB端";
      }
    },

    //显示状态，type=1列表用，type=2详情用
    stateFormat(row, type) {
      if (row.state == 1) {
        if (type == 1) {
          row.statename = "待分配";
          return "warning";
        }
        return "待分配";
      } else if (row.state == 2) {
        if (type == 1) {
          row.statename = "待解决";
          return "primary";
        }
        return "待解决";
      } else {
        if (type == 1) {
          row.statename = "已解决";
          return "success";
        }
        return "已解决";
      }
    },

    handleTabClick(tab) {
      if (tab.name == "fourth") {
        this.viewLoading = true;
        this.activities = [];
        this.$ajax
          .get("/buss/fault/list_fau_process", { fauId: this.faultInfo.id })
          .then((msg) => {
            msg.forEach((ele) => {
              this.fauProcess = {};
              this.fauProcess.content =
                (ele.senderName == null ? "" : ele.senderName) +
                "【" +
                (ele.des == null ? "" : ele.des) +
                "】" +
                (ele.receiverName == null ? "" : ele.receiverName);
              this.fauProcess.timestamp = ele.createTime;
              this.fauProcess.color = "#0bbd87";
              this.fauProcess.icon = "el-icon-star-on";
              this.activities.push(this.fauProcess);
            });
          })
          .finally(() => {
            this.viewLoading = false;
          })
          .catch((err) => {
            this.$message.error(err);
            this.viewLoading = false;
          });
      }

      if (tab.name == "third") {
        this.viewLoading = true;
        this.matConsume = [];
        this.$ajax
          .get("/buss/fault/list_mat_consume", { fauId: this.faultInfo.id })
          .then((msg) => {
            this.matConsume = msg;
          })
          .finally(() => {
            this.viewLoading = false;
          })
          .catch((err) => {
            this.$message.error(err);
            this.viewLoading = false;
          });
      }
    },
    changeOutTime(row) {
      let hours = parseInt(
        (new Date(row.arriveTime) - new Date(row.occuTime)) / (1000 * 60 * 60)
      );
      //计算天数后剩余的毫秒数
      let leave1 =
        (new Date(row.arriveTime).getTime() -
          new Date(row.occuTime).getTime()) %
        (24 * 3600 * 1000);
      let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000));
      let a = minutes == "0" ? hours : hours + 1;
      return a;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style></style>
